import { PrintingOrderJsonldPrintingOrderPartnerRead } from '@/api/generated';
import { VARIANT_COLOR_ENUM } from '@/types/utils';

export const CARDS_PER_PRINTING_PAGE = 20;
export const PRINTING_ORDER_PER_PAGE = 12;

export const PRINTING_STATUS_VARIANT: Record<
  PrintingOrderJsonldPrintingOrderPartnerRead['status'],
  VARIANT_COLOR_ENUM
> = {
  DRAFT: VARIANT_COLOR_ENUM.PRIMARY,
  CONFIRMED: VARIANT_COLOR_ENUM.SUCCESS,
  INTEGRATED: VARIANT_COLOR_ENUM.SUCCESS,
  SHIPPED: VARIANT_COLOR_ENUM.INFO,
  DELIVERED: VARIANT_COLOR_ENUM.SUCCESS,
  INTEGRATION_ERROR: VARIANT_COLOR_ENUM.ERROR,
  PENDING_CARD_REGENERATION: VARIANT_COLOR_ENUM.PRIMARY,
  REFUNDED: VARIANT_COLOR_ENUM.INFO,
  CANCELED: VARIANT_COLOR_ENUM.NEUTRAL,
  TO_VERIFY: VARIANT_COLOR_ENUM.SECONDARY,
};

export const PRINTING_STATUS_LABEL: Record<PrintingOrderJsonldPrintingOrderPartnerRead['status'], string> = {
  DRAFT: 'printing.status.draft',
  CONFIRMED: 'printing.status.confirmed',
  INTEGRATED: 'printing.status.integrated',
  SHIPPED: 'printing.status.shipped',
  DELIVERED: 'printing.status.delivered',
  INTEGRATION_ERROR: 'printing.status.integrationError',
  PENDING_CARD_REGENERATION: 'printing.status.cardRegeneration',
  REFUNDED: 'printing.status.refund',
  CANCELED: 'printing.status.canceled',
  TO_VERIFY: 'printing.status.toVerify',
};
export const PRINTING_STATUS_ICON: Record<PrintingOrderJsonldPrintingOrderPartnerRead['status'], string | undefined> = {
  DRAFT: 'fa-solid fa-turtle',
  CONFIRMED: 'fa-solid fa-money-bills-simple',
  INTEGRATED: 'fa-solid fa-money-bills-simple',
  SHIPPED: 'fa-solid fa-paper-plane',
  DELIVERED: 'fa-solid fa-mailbox-flag-up',
  INTEGRATION_ERROR: 'fa-solid fa-circle-exclamation',
  PENDING_CARD_REGENERATION: undefined,
  TO_VERIFY: undefined,
  REFUNDED: undefined,
  CANCELED: undefined,
};
